import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import BlogMeta from './BlogMeta';

export default function BlogCard({ post }) {
  return (
    <article className="group flex flex-col bg-white dark:bg-dark-bg-secondary border border-gray-200 dark:border-dark-border rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
      {post.featuredImage && (
        <Link to={`/blog/${post.slug}`} className="block aspect-video overflow-hidden">
          <img
            src={post.featuredImage}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </Link>
      )}

      <div className="flex flex-col flex-1 p-6">
        <BlogMeta post={post} />

        <Link to={`/blog/${post.slug}`} className="mt-3">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors line-clamp-2">
            {post.title}
          </h2>
        </Link>

        <p className="mt-2 text-gray-600 dark:text-gray-400 leading-relaxed line-clamp-3 flex-1">
          {post.excerpt}
        </p>

        <Link
          to={`/blog/${post.slug}`}
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-600 dark:text-emerald-400 hover:gap-2.5 transition-all"
        >
          Read more
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
